import React, { useState, useEffect } from 'react'
import Classes from './Invoices.module.css'
import RecordTable from './RecordTable/RecordTable'

export default function Invoices() {

    return (
        <div className={Classes.hero}>
            <div className={Classes.header}>
                <div>
                    <h3 className={Classes.title3} >Invoices</h3>
                    <h5 className={Classes.text} >View and pay your invoices.</h5>
                </div>
                <div>
                    <div className={Classes.searcCon}>
                        <img src="/assets/images/search.png" alt="icon" />
                        <input type="text" placeholder="Search..." />
                    </div>
                </div>
            </div>

            <RecordTable />
        </div>
    )
}
